// extracted by mini-css-extract-plugin
module.exports = {"container":"template_container__nMq_H"};